import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdvertisingService } from "../../master-services/advertising-services/advertising.service";
import swal from "sweetalert2";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "advertising-component",
  templateUrl: "./advertising.component.html",
  styleUrls: ["./advertising.component.scss"],
})
export class AdvertisingComponent implements OnInit {
  imgList: any;
  myForm: FormGroup;
  files: any = [];
  previsualizacion: string;
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private AdvertisingService: AdvertisingService,
    private sanitizer: DomSanitizer
  ) {
    this.index();
    const img = new FormControl();
    this.myForm = new FormGroup({
      img: img,
    });
  }
  ngOnInit() {}

  index() {
    this.AdvertisingService.index().then((data) => {
      const resp: any = data;
      this.imgList = resp.data;
      console.log(this.imgList);
    });
  }

  extraerBase64 = async ($event: any) =>
    new Promise((resolve, reject) => {
      try {
        const unsafeImg = window.URL.createObjectURL($event);
        const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
        const reader = new FileReader();
        reader.readAsDataURL($event);
        reader.onload = () => {
          resolve({
            base: reader.result,
          });
        };
        reader.onerror = (error) => {
          resolve({
            base: null,
          });
        };
      } catch (e) {
        return null;
      }
    });

  capturarFile(event: any) {
    const capturedFile = event.target.files[0];
    this.files.push(capturedFile);
    this.extraerBase64(capturedFile).then((imagen: any) => {
      this.previsualizacion = imagen.base;
    });
  }

  addimg() {
    if (!this.myForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.AdvertisingService.storImg(this.previsualizacion)
        .then((data) => {
          const resp: any = data;
          console.log(resp);
          if (resp.success === false) {
            console.log(resp.message);
            swal({
              title: "Mensaje ",
              text: resp.message.nameList,
              type: "error",
            });
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
              text: resp.message,
            });

            this.index();
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  }


  publicImg(id) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.AdvertisingService.publicImg(id).then((data) => {
      const resp: any = data;
      this.imgList = resp.data;
      swal({
        title: "Tercero agregado",
        type: "success",
        text: resp.message,
      });
    });
    this.index();



  }

}



// WEBPACK FOOTER //
// ./src/app/master/advertising/advertising.component.ts